import { useSelector } from "react-redux";
import { selectCurrentUser } from "app/slices/user/userSlice";
import { UserTypeIds } from "app/slices/user/UserModel";
import AdminLayout from "./AdminLayout";
import MainLayout from "./MainLayout";

/**
 * LayoutRouter - Routes to correct layout based on user type
 * Handles the structural layout selection, while pages handle content/data
 */
export default function LayoutRouter() {
  const currentUserTypeId = useSelector(selectCurrentUser).userTypeId;

  switch (currentUserTypeId) {
    case UserTypeIds.Admin:
      return <AdminLayout />;
    default:
      return <MainLayout />;
  }
}
